module.exports = __webpack_public_path__ + "static/media/htmlLogo.eea2dc09.png";